<template>
    <div class="editor">
        <jodit-vue v-model="internalNote" :buttons="buttons" class="form-control" name="content"></jodit-vue>
        <div class="edit-buttons mt-2">
            <button class="btn save" @click="saveInternalNote"><saveicon class="svg-24"></saveicon> Save</button>
            <button class="btn btn-default btn-grey cancel" @click="closeInternalNote"><cancelicon class="svg-24"></cancelicon> Cancel</button>
        </div>
    </div>
</template>

<script>
import saveicon from '../components/icons/save.vue';
import cancelicon from '../components/icons/circle_close.vue';
import 'jodit/build/jodit.min.css'
import { JoditVue } from 'jodit-vue'

export default {
    components: {JoditVue, saveicon, cancelicon},
    props: ['actionurl', 'internal_note_loaded'],
    data() {
        return {
            buttons: ['bold', 'underline', 'italic', 'eraser', 'ul', 'ol', 'link'],
            internalNote: '',
            editOrAdd: 'Add',
            originalInternalNote: '',
        }
    },
    created: function() {
        this.originalInternalNote = this.internal_note_loaded;
        this.internalNote = this.internal_note_loaded;
    },
    methods: {
        saveInternalNote: function() {
            let that = this;
            window.axios({
                method: 'put',
                url: this.actionurl,
                data: {
                    internal_note: that.internalNote
                }
            }).then(function(response) {
                that.originalInternalNote = that.internalNote;
                that.$emit('closeModal', that.internalNote);
            }).catch(function (error) {
                console.log('This is the error returned', error);
            });
        },
        closeInternalNote: function() {
            this.internalNote = this.originalInternalNote;
            this.$emit('closeModal', this.internalNote);
        }
    }
}
</script>
